/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TemplateRecommendedReleasesReleases,
    TemplateRecommendedReleasesReleasesFromJSON,
    TemplateRecommendedReleasesReleasesFromJSONTyped,
    TemplateRecommendedReleasesReleasesToJSON,
} from './TemplateRecommendedReleasesReleases';

/**
 * テンプレートに紐づく推奨のプレスリリース
 * @export
 * @interface TemplateRecommendedReleases
 */
export interface TemplateRecommendedReleases {
    /**
     * 
     * @type {number}
     * @memberof TemplateRecommendedReleases
     */
    purposeId: number;
    /**
     * 
     * @type {number}
     * @memberof TemplateRecommendedReleases
     */
    templateId: number;
    /**
     * 配信目的カテゴリ名
     * @type {string}
     * @memberof TemplateRecommendedReleases
     */
    categoryName: string;
    /**
     * 配信目的名
     * @type {string}
     * @memberof TemplateRecommendedReleases
     */
    purposeName: string;
    /**
     * 
     * @type {Array<TemplateRecommendedReleasesReleases>}
     * @memberof TemplateRecommendedReleases
     */
    releases: Array<TemplateRecommendedReleasesReleases>;
}

export function TemplateRecommendedReleasesFromJSON(json: any): TemplateRecommendedReleases {
    return TemplateRecommendedReleasesFromJSONTyped(json, false);
}

export function TemplateRecommendedReleasesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplateRecommendedReleases {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purposeId': json['purpose_id'],
        'templateId': json['template_id'],
        'categoryName': json['category_name'],
        'purposeName': json['purpose_name'],
        'releases': ((json['releases'] as Array<any>).map(TemplateRecommendedReleasesReleasesFromJSON)),
    };
}

export function TemplateRecommendedReleasesToJSON(value?: TemplateRecommendedReleases | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purpose_id': value.purposeId,
        'template_id': value.templateId,
        'category_name': value.categoryName,
        'purpose_name': value.purposeName,
        'releases': ((value.releases as Array<any>).map(TemplateRecommendedReleasesReleasesToJSON)),
    };
}

